import { render, staticRenderFns } from "./ProgramResources.vue?vue&type=template&id=b3283c98&"
import script from "./ProgramResources.vue?vue&type=script&lang=js&"
export * from "./ProgramResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports